module.exports = __webpack_public_path__ + "img/right.8faae47c.png";